import React, { useLayoutEffect, useState } from 'react'
import api from './api'

import { Input, message, Space, Typography, Result, Button } from 'antd'

const { Text, Title, Link } = Typography

function encodeBase64(text) {
    // 将字符串转换为UTF-8编码的字节序列
    const utf8Bytes = new TextEncoder().encode(text);
    // 使用浏览器内置的btoa函数，但先转换为二进制字符串
    let binaryString = '';
    utf8Bytes.forEach(byte => {
        binaryString += String.fromCharCode(byte);
    });
    return btoa(binaryString);
}


//  用户协议布局
function BindingPhone(props) {
    // const [bindPhone, setBindPhone] = useState(false)
    const [bindPhoneData, setBindPhoneData] = useState({ phone_number: '', vcode: '' })
    const [bindPhoneCodeData, setBindPhoneCodeData] = useState(false)

    useLayoutEffect(() => {
        setTimeout(() => {
            window.initGeetest4({
                captchaId: 'e2f7db7a36cae0fcec9320216a172878',
                nativeButton: {
                    width: '200px',
                },
            }, function (captcha) {
                // captcha为验证码实例
                captcha.appendTo("#DX_demo_Phone");// 调用appendTo将验证码插入到页的某一个元素中，这个元素用户可以自定义

                captcha.onReady(function () {
                    //your code
                }).onSuccess(function () {
                    var token = captcha.getValidate()
                    setBindPhoneCodeData(token)

                    //your code
                }).onError(function () {
                    //your code
                })
            });
        }, 500);
    }, [])

    function onChange(e) {
        setBindPhoneData({
            ...bindPhoneData,
            [e.target.name]: e.target.value
        })
    }

    //  获取验证码
    function get_verification_code() {
        let phone = bindPhoneData.phone_number


        if (!phone || typeof phone !== 'string' || !/^1[3-9]\d{9}$/.test(phone)) {
            return message.error('手机号格式不正确, 请重新填写!')
        }

        if (!bindPhoneCodeData) {
            message.warning('请完成人机验证')
            return
        }

        api.post('/api/v2/user/send_sms', {
            type: 'get_sms_code',
            value: {
                phone_number: encodeBase64(encodeBase64(phone)),
            },
            botToken: bindPhoneCodeData,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    message.success('已经下发验证码, 请查收短信验证码!')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器 error: ' + error)
            })

        // message.success('已经下发验证码, 请查收短信验证码!')
    }

    //  确定绑定
    function v_verification_code() {
        let phone = bindPhoneData.phone_number


        if (!phone || typeof phone !== 'string' || !/^1[3-9]\d{9}$/.test(phone)) {
            return message.error('手机号格式不正确, 请重新填写!')
        }

        if (!bindPhoneData.vcode) {
            message.warning('请填写验证码')
            return
        }

        if (!bindPhoneCodeData) {
            message.warning('请完成人机验证')
            return
        }

        api.post('/api/v2/user/send_sms', {
            type: 'v_sms_code',
            value: {
                phone_number: encodeBase64(encodeBase64(phone)),
                vcode: bindPhoneData.vcode,
            }
        })
            .then((res) => {
                if (res.data.code === 200) {
                    message.success('成功绑定, 请刷新页面!')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }


    if (props.state.user.phone_number) {
        return (
            <Result title="此账户已完成绑定手机操作" />
        )
    }

    if (!props.state.token) {
        // navigate('/login')
        return (
            <Result
                status="403"
                title="403"
                subTitle="请登录再访问页面"
            />
        )
    }

    return (
        <div style={{ width: 300, margin: 'auto', marginTop: 40 }}>
            <Title style={{ textAlign: 'center' }} level={3}>绑定手机</Title>
            <p style={{ color: '#fff' }}>根据本站的 <Link href="/useragreement" target='_blank'>《用户协议》</Link> 要求, 你需要绑定手机号才能正常使用相关功能</p>

            <div style={{ marginTop: 20 }}>
                <div style={{ width: '300px' }}>
                    <Text>手机号</Text>
                    <br />
                    <Space.Compact
                        style={{ marginTop: 5, width: '90%' }}
                    >
                        <Input name='phone_number' onChange={onChange} value={bindPhoneData.phone_number} />
                        <Button type="primary" onClick={() => { get_verification_code() }}>获取验证码</Button>
                    </Space.Compact>
                </div>

                <div id="DX_demo_Phone" style={{ marginBottom: 20, marginTop: 20 }}></div>

                <div style={{ marginTop: 20, width: '100px' }}>
                    <Text>验证码</Text>
                    <br />
                    <Input style={{ width: '90%' }} name='vcode' onChange={onChange} value={bindPhoneData.vcode} />
                </div>

                <div style={{ marginTop: 20 }}>
                    <Button type="primary" block onClick={v_verification_code}>进行绑定</Button>
                </div>
            </div>
        </div>
    );
}

export default BindingPhone